import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, finalize, Observable, Subject, switchMap, takeUntil } from 'rxjs';
import { APIHandlerService } from 'src/@services/apihandler.service';

@Injectable()
export class PendingRequestsInterceptor implements HttpInterceptor {
  private logoutSubject = new Subject<void>();

  constructor(private pendingRequestsService: APIHandlerService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const cancelSubject = new Subject<void>();

    // Add the request to the pending requests service
    this.pendingRequestsService.addRequest(request, cancelSubject);

    return next.handle(request).pipe(
      // takeUntil(this.logoutSubject),
      switchMap((event) => {
        if (event instanceof HttpResponse) {
          // Request was successful, remove it from the pending requests
          this.pendingRequestsService.removeRequest(request);
        }
        return [event];
      }),
      catchError((error: HttpErrorResponse) => {
        // Request failed, remove it from the pending requests
        this.pendingRequestsService.removeRequest(request);
        throw error;
      }),
      finalize(() => {
        // Cleanup: remove the request if not completed
        this.pendingRequestsService.removeRequest(request);
      })
    );
  }
}
